goog.provide('yext.m4.confcode.adminconsole.init');

goog.require('yext.m4.confcode.adminconsole.AdminConsoleController');

/**
 * Initialize javascript for the Admin Console.
 *
 * @author Benjamin Leitner (bleitner@yext.com)
 */
$(document).ready(function() {
  var initIdentifier = $('.js-adminconsole-container').data('jsinit');
  switch (initIdentifier) {
    case 'adminconsole_overview':
      new yext.m4.confcode.adminconsole.AdminConsoleController();
      break;
  }
});
